var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"center","align-content":"flex-start","flex-wrap":"wrap"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }